setTimeout(function() {
  if(document.querySelector('.js-showCustomer-scans') != null){
     document.querySelector('.js-showCustomer-scans').addEventListener('click', (e) =>{
        e.preventDefault();
        document.querySelector('.js-account-content').classList.add('is--scanActive');
        window.scrollTo({top: 0, behavior: 'smooth'});
    });
    
    document.querySelector('.js-hide-scan').addEventListener('click', (e) =>{
        e.preventDefault();
        document.querySelector('.js-account-content').classList.remove('is--scanActive');
    });
  }

  if(document.querySelectorAll('.js-calendly-active').length != 0){
     document.querySelectorAll('.js-calendly-active').forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          document.querySelector('.calendly-badge-content').click();
        });
    }); 
  }
  
  if(document.querySelector('.js-calendly-drawer') != null){
      document.querySelector('.js-calendly-drawer').addEventListener("click", (e) => {
        e.preventDefault();
        document.querySelector('#site-scanCart').classList.add('active');
        document.querySelector('#site-scanCart').style.display = 'block';
        document.querySelector('#site-overlay').classList.add('active');
        document.body.classList.add('calendly-active');
      });
  }

}, 1000);